"use strict";

/**
* Retrieves a reCAPTCHA token and executes a callback function with the token as an argument.
* This function utilizes Google's reCAPTCHA v3 to verify user interactions on the client-side.
*
* @param {Function} callback - A callback function that is executed once the reCAPTCHA token is retrieved. 
*                              The token is passed as an argument to this function.
* @param {string} [actionParam="submit"] - An optional parameter specifying the action name for the reCAPTCHA request.
*                                          Defaults to "submit" if not provided.
* @returns {void} - This function does not return a value. It executes the callback with the token or without it if the reCAPTCHA key is not available.
*/
function getRecaptchaToken(callback, actionParam) {
    var action = actionParam || "submit";
    var recaptchaKey = $("#recaptchaSiteKey").val();
    if (recaptchaKey) {
        var grecaptcha = window.grecaptcha;
        grecaptcha.ready(function () {
            grecaptcha.execute(recaptchaKey, {action: action}).then(function (token) {
                callback(token);
            });
        });
    } else {
        return callback();
    }
}

module.exports = {
    getRecaptchaToken: getRecaptchaToken
};
